import Vue from 'vue'
import App from './App.vue'
import store from './store';
import VueRouter from 'vue-router'
import VueMaterial from 'vue-material'
import SvgPanZoom from 'vue-svg-pan-zoom';

import Row from './components/Theatre/Row.vue';
import Seat from './components/Theatre/Seat.vue';
import Theatre from './components/Theatre/Theatre.vue';

import Sold from './components/Admin/Tickets/Sold.vue';
import Plays from './components/Admin/Tickets/Plays.vue';
import Stages from './components/Admin/Tickets/Stages.vue';
import Leases from './components/Admin/Tickets/Leases.vue';
import Offers from './components/Admin/Tickets/Offers.vue';
import Seasons from './components/Admin/Tickets/Seasons.vue';
import KontoHR from './components/Admin/Tickets/KontoHR.vue';
import Partners from './components/Admin/Tickets/Partners.vue';
import Sponsors from './components/Admin/Tickets/Sponsors.vue';
import Discounts from './components/Admin/Tickets/Discounts.vue';
import Pricelists from './components/Admin/Tickets/Pricelists.vue';
import ReportsPlay from './components/Admin/Tickets/ReportsPlay.vue';
import ReportsCash from './components/Admin/Tickets/ReportsCash.vue';
import Performances from './components/Admin/Tickets/Performances.vue';
import ReportsIncome from './components/Admin/Tickets/ReportsIncome.vue';
import ReportsAboutPlay from './components/Admin/Tickets/ReportsAboutPlay.vue';
import ReportsAboutScan from './components/Admin/Tickets/ReportsAboutScan.vue';
import ReportsPlayOnline from './components/Admin/Tickets/ReportsPlayOnline.vue';
import ReportsGeneralAll from './components/Admin/Tickets/ReportsGeneralAll.vue';
import ReportsCashRegister from './components/Admin/Tickets/ReportsCashRegister.vue';
import ReportsGratisByDate from './components/Admin/Tickets/ReportsGratisByDate.vue';
import ReportsCashRegisterPlay from './components/Admin/Tickets/ReportsCashRegisterPlay.vue';
import ReportsPerformanceGeneral from './components/Admin/Tickets/ReportsPerformanceGeneral.vue';
import ShowScreen from './components/Admin/Tickets/ShowScreen.vue';
import ReportsInGuests from './components/Admin/Tickets/ReportsInGuests.vue';

import Admin from './components/Admin/Admin.vue';
import Coupons from './components/Admin/Coupons.vue';
import PromoCodes from './components/Admin/PromoCodes.vue';
import Employees from './components/Admin/Employees.vue';
import WorkPlaces from './components/Admin/WorkPlaces.vue';
import Autocomplete from './components/Admin/Autocomplete.vue';
import AdminTheatre from './components/Admin/AdminTheatre.vue';
import Transactions from './components/Admin/Transactions.vue';
import TicketTheatre from './components/Admin/TicketTheatre.vue';
import EditTransaction from './components/Admin/EditTransaction.vue';
import TransactionsCoupon from './components/Admin/TransactionsCoupon.vue';
import TransactionDetails from './components/Admin/TransactionDetails.vue';
import MultiTransactionDetails from './components/Admin/MultiTransactionDetails.vue';
import SubscriptionTheatre from './components/Admin/SubscriptionTheatre.vue';



import SelectedSeats from './components/Admin/Theatre/SelectedSeats.vue';
import TheatreLegend from './components/Admin/Theatre/TheatreLegend.vue';

import Prices from './components/Admin/Subscriptions/Prices.vue';
import Subscribers from './components/Admin/Subscriptions/Subscribers.vue';
import Subscriptions from './components/Admin/Subscriptions/Subscriptions.vue';
import ReportsGeneral from './components/Admin/Subscriptions/ReportsGeneral.vue';
import ReportsPayment from './components/Admin/Subscriptions/ReportsPayment.vue';
import SubscribersDialog from './components/Admin/Subscriptions/SubscribersDialog.vue';



import 'vue-material/dist/vue-material.min.css';

import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

Vue.use(Datetime)
Vue.use(VueRouter);

Vue.use(VueMaterial)
Vue.component('Row', Row);
Vue.component('Seat', Seat);
Vue.component('Sold', Sold);
Vue.component('Admin', Admin);
Vue.component('Plays', Plays);
Vue.component('Prices', Prices);
Vue.component('Stages', Stages);
Vue.component('Leases', Leases);
Vue.component('Offers', Offers);
Vue.component('Theatre', Theatre);
Vue.component('Seasons', Seasons);
Vue.component('KontoHR', KontoHR);
Vue.component('Coupons', Coupons);
Vue.component('Partners', Partners);
Vue.component('Sponsors', Sponsors);
Vue.component('Discounts', Discounts);
Vue.component('Employees', Employees);
Vue.component('WorkPlaces', WorkPlaces);
Vue.component('Pricelists', Pricelists);
Vue.component('SvgPanZoom', SvgPanZoom);
Vue.component('Subscribers', Subscribers);
Vue.component('ReportsPlay', ReportsPlay);
Vue.component('ReportsCash', ReportsCash);
Vue.component('Performances', Performances);
Vue.component('Transactions', Transactions);
Vue.component('Autocomplete', Autocomplete);
Vue.component('AdminTheatre', AdminTheatre);
Vue.component('TicketTheatre', TicketTheatre);
Vue.component('Subscriptions', Subscriptions);
Vue.component('SelectedSeats', SelectedSeats);
Vue.component('TheatreLegend', TheatreLegend);
Vue.component('ReportsIncome', ReportsIncome);
Vue.component('ReportsGeneral', ReportsGeneral);
Vue.component('ReportsPayment', ReportsPayment);
Vue.component('EditTransaction', EditTransaction);
Vue.component('ReportsAboutPlay', ReportsAboutPlay);
Vue.component('ReportsAboutScan', ReportsAboutScan);
Vue.component('ReportsPlayOnline', ReportsPlayOnline);
Vue.component('ReportsGeneralAll', ReportsGeneralAll);
Vue.component('SubscribersDialog', SubscribersDialog);
Vue.component('TransactionDetails', TransactionDetails);
Vue.component('MultiTransactionDetails', MultiTransactionDetails);
Vue.component('TransactionsCoupon', TransactionsCoupon);
Vue.component('ReportsCashRegister', ReportsCashRegister);
Vue.component('SubscriptionTheatre', SubscriptionTheatre);
Vue.component('ReportsGratisByDate', ReportsGratisByDate);
Vue.component('ReportsCashRegisterPlay', ReportsCashRegisterPlay);
Vue.component('ReportsPerformanceGeneral', ReportsPerformanceGeneral);
Vue.component('ShowScreen', ShowScreen);
Vue.component('ReportsInGuests', ReportsInGuests);

const routes = [
  {path: '/hnk-4dm1n-t1ck3t/prodano', component: Sold},
  {path: '/hnk-4dm1n-t1ck3t/ponude', component: Offers},
  {path: '/hnk-4dm1n-t1ck3t/zakupi', component: Leases},
  {path: '/hnk-4dm1n-t1ck3t/kuponi', component: Coupons},
  {path: '/hnk-4dm1n-t1ck3t/promo-kodovi', component: PromoCodes},
  {path: '/hnk-4dm1n-t1ck3t/', component: Subscriptions},
  {path: '/hnk-4dm1n-t1ck3t/sezone', component: Seasons},
  {path: '/hnk-4dm1n-t1ck3t/predstave', component: Plays},
  {path: '/hnk-4dm1n-t1ck3t/konto-hr', component: KontoHR},
  {path: '/hnk-4dm1n-t1ck3t/pozornice', component: Stages},
  {path: '/hnk-4dm1n-t1ck3t/sponzori', component: Sponsors},
  {path: '/hnk-4dm1n-t1ck3t/popusti', component: Discounts},
  {path: '/hnk-4dm1n-t1ck3t/cjenici', component: Pricelists},
  {path: '/hnk-4dm1n-t1ck3t/raspored', component: Performances},
  {path: '/hnk-4dm1n-t1ck3t/zaposlenici', component: Employees},
  {path: '/hnk-4dm1n-t1ck3t/radna-mjesta', component: WorkPlaces},
  {path: '/hnk-4dm1n-t1ck3t/pretplate', component: Subscriptions},
  {path: '/hnk-4dm1n-t1ck3t/pretplatnici', component: Subscribers},
  {path: '/hnk-4dm1n-t1ck3t/poslovni-partneri', component: Partners},
  {path: '/hnk-4dm1n-t1ck3t/tlocrt-ulaznice', component: TicketTheatre},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/gotovinsko', component: ReportsCash},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/po-predstavi', component: ReportsPlay},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/o-izvedbi', component: ReportsAboutPlay},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/skenirano', component: ReportsAboutScan},
  {path: '/hnk-4dm1n-t1ck3t/tlocrt-pretplate', component: SubscriptionTheatre},
  {path: '/hnk-4dm1n-t1ck3t/tlocrt-ulaznice/:type', component: TicketTheatre},
  {path: '/hnk-4dm1n-t1ck3t/kuponi/transakcije', component: TransactionsCoupon},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/po-pretplatama', component: ReportsGeneral},
  {path: '/hnk-4dm1n-t1ck3t/detalji-transakcije', component: TransactionDetails},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/promet-u-periodu', component: ReportsIncome},
  {path: '/hnk-4dm1n-t1ck3t/transakcije/ulaznice/:type', component: Transactions},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/blagajnicki', component: ReportsCashRegister},
  {path: '/hnk-4dm1n-t1ck3t/transakcije/pretplate/:type', component: Transactions},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/po-nacinu-placanja', component: ReportsPayment},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/po-predstavi-online', component: ReportsPlayOnline},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/gratis-po-danima', component: ReportsGratisByDate},
  {path: '/hnk-4dm1n-t1ck3t/detalji-transakcije/uredivanje', component: EditTransaction},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/kumulativni', component: ReportsPerformanceGeneral},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/kumulativni-sve-predstave', component: ReportsGeneralAll},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/blagajnicki-predstava', component: ReportsCashRegisterPlay},
  {path: '/hnk-4dm1n-t1ck3t/show-screen', component: ShowScreen},
  {path: '/hnk-4dm1n-t1ck3t/izvjesca/u-gostima', component: ReportsInGuests},
]

const router = new VueRouter({
  routes,
  mode: 'history',
});

let appContainer = document.getElementById('app');

store.state.csrf = appContainer.dataset.csrf;
store.state.window = window;
if(document.querySelectorAll('[name="transaction_subscription_url"]')[0] !== undefined){
  let transactionSubscriptionListsUrl = document.querySelectorAll('[name="transaction_subscription_url"]')[0].getAttribute('content');
  store.state.urls.transactionsSubscription = transactionSubscriptionListsUrl;
}

if(document.querySelectorAll('[name="transaction_ticket_url"]')[0] !== undefined){
  let transactionTicketListsUrl = document.querySelectorAll('[name="transaction_ticket_url"]')[0].getAttribute('content');
  store.state.urls.transactionsTicket = transactionTicketListsUrl;
}

if(document.querySelectorAll('[name="check_promo_code_url"]')[0] !== undefined){
  let checkPromoCodeUrl = document.querySelectorAll('[name="check_promo_code_url"]')[0].getAttribute('content');
  store.state.urls.checkPromoCode = checkPromoCodeUrl;
}


if(document.querySelectorAll('[name="transaction_coupon_url"]')[0] !== undefined){
  let transactionCouponListsUrl = document.querySelectorAll('[name="transaction_coupon_url"]')[0].getAttribute('content');
  store.state.urls.transactionsCoupon = transactionCouponListsUrl;
}

if(appContainer.dataset.type !== undefined){
  if(appContainer.dataset.type == 'ticket'){
    store.state.isTheatre = true;
    store.state.defaultPricelistID = appContainer.dataset.pricelist;
  } else if(appContainer.dataset.type == 'subscription'){
    store.state.isSubscription = true;
  }
}

if(appContainer.dataset.admin !== undefined){
  store.state.router = router;
  store.state.isAdmin = true;
  store.state.schemaUrl = document.querySelectorAll('[name="schema_url"]')[0].getAttribute('content');
  store.state.urls.login = document.querySelectorAll('[name="login_url"]')[0].getAttribute('content');
  store.state.urls.plays = document.querySelectorAll('[name="plays_url"]')[0].getAttribute('content');
  store.state.urls.logout = document.querySelectorAll('[name="logout_url"]')[0].getAttribute('content');
  store.state.urls.stages = document.querySelectorAll('[name="stages_url"]')[0].getAttribute('content');
  store.state.urls.leases = document.querySelectorAll('[name="leases_url"]')[0].getAttribute('content');
  store.state.urls.kontoHR = document.querySelectorAll('[name="accounting"]')[0].getAttribute('content');
  store.state.urls.seasons = document.querySelectorAll('[name="season_url"]')[0].getAttribute('content');
  store.state.urls.coupons = document.querySelectorAll('[name="coupons_url"]')[0].getAttribute('content');
  store.state.urls.sponsors = document.querySelectorAll('[name="sponsors_url"]')[0].getAttribute('content');
  store.state.urls.partners = document.querySelectorAll('[name="partners_url"]')[0].getAttribute('content');
  store.state.urls.employees = document.querySelectorAll('[name="employees_url"]')[0].getAttribute('content');
  store.state.urls.promoCodes = document.querySelectorAll('[name="promo_codes_url"]')[0].getAttribute('content');
  store.state.urls.discounts = document.querySelectorAll('[name="discounts_url"]')[0].getAttribute('content');
  store.state.urls.seasonsList = document.querySelectorAll('[name="seasons_url"]')[0].getAttribute('content');
  store.state.urls.reportsCash = document.querySelectorAll('[name="reports_cash"]')[0].getAttribute('content');
  store.state.urls.workPlaces = document.querySelectorAll('[name="workPlaces_url"]')[0].getAttribute('content');
  store.state.urls.pricelists = document.querySelectorAll('[name="price_lists_url"]')[0].getAttribute('content');
  store.state.urls.subscribers = document.querySelectorAll('[name="subscribers_url"]')[0].getAttribute('content');
  store.state.urls.resendMail = document.querySelectorAll('[name="resend_mail_url"]')[0].getAttribute('content');
  store.state.urls.ticketSales = document.querySelectorAll('[name="ticketSales_url"]')[0].getAttribute('content');
  store.state.urls.reportsPlay = document.querySelectorAll('[name="reports_play_url"]')[0].getAttribute('content');
  store.state.urls.performances = document.querySelectorAll('[name="performances_url"]')[0].getAttribute('content');
  store.state.urls.reservations = document.querySelectorAll('[name="reservations_url"]')[0].getAttribute('content');
  store.state.urls.subscription = document.querySelectorAll('[name="subscirptions_url"]')[0].getAttribute('content');
  store.state.urls.emptyTheatre = document.querySelectorAll('[name="empty_theatre_url"]')[0].getAttribute('content');
  store.state.urls.reportsIncome = document.querySelectorAll('[name="reports_income_url"]')[0].getAttribute('content');
  store.state.urls.pricelistsList = document.querySelectorAll('[name="pricelistsList_url"]')[0].getAttribute('content');
  store.state.urls.reportsGeneral = document.querySelectorAll('[name="reports_general_url"]')[0].getAttribute('content');
  store.state.urls.reportsPayment = document.querySelectorAll('[name="reports_payment_url"]')[0].getAttribute('content');
  store.state.urls.subscriberPostUrl = document.querySelectorAll('[name="subscriber_post_url"]')[0].getAttribute('content');
  store.state.urls.reportsGeneralAll = document.querySelectorAll('[name="reports_general_all"]')[0].getAttribute('content');
  store.state.urls.reportsAboutPlay = document.querySelectorAll('[name="reports_about_play_url"]')[0].getAttribute('content');
  store.state.urls.reportsAboutScan = document.querySelectorAll('[name="reports_about_scan_url"]')[0].getAttribute('content');
  store.state.urls.subscriptionSales = document.querySelectorAll('[name="subscriptionSales_url"]')[0].getAttribute('content');
  store.state.urls.subscribersExport = document.querySelectorAll('[name="subscribers_export_url"]')[0].getAttribute('content');
  store.state.urls.reportsPlayOnline = document.querySelectorAll('[name="reports_play_online_url"]')[0].getAttribute('content');
  store.state.urls.ticketTheatreCopy = document.querySelectorAll('[name="ticket_theatre_copy_url"]')[0].getAttribute('content');
  store.state.urls.performancesSimple = document.querySelectorAll('[name="performances_simple_url"]')[0].getAttribute('content');
  store.state.urls.subscriptionBundle = document.querySelectorAll('[name="subscirptions_bundle_url"]')[0].getAttribute('content');
  store.state.urls.reportsCashRegister = document.querySelectorAll('[name="reports_cash_register_url"]')[0].getAttribute('content');
  store.state.urls.transactionTicketEdit = document.querySelectorAll('[name="transaction_ticket_edit"]')[0].getAttribute('content');
  store.state.urls.reportsGratisByDate = document.querySelectorAll('[name="reports_gratis_by_date_url"]')[0].getAttribute('content');
  store.state.urls.reportsPerformanceGeneral = document.querySelectorAll('[name="reports_performance_general"]')[0].getAttribute('content');
  store.state.urls.showScreen = document.querySelectorAll('[name="show_screen_url"]')[0].getAttribute('content');
  store.state.urls.reportsInGuests = document.querySelectorAll('[name="reports_in_guests"]')[0].getAttribute('content');

  store.dispatch('getSchema');

  store.dispatch('getData', ({
    url: store.state.urls.seasons,
    stateObject: 'seasons',
  }));

  store.dispatch('getData', ({
    url: store.state.urls.seasonsList,
    stateObject: 'seasonsList',
  }));
  store.dispatch('getEmptyTheatre');
  //store.dispatch('checkForUpdates');
} else{
  if(store.state.isTheatre){
    let ticketTheatreUrl = document.querySelectorAll('[name="ticket_theatre_url"]')[0].getAttribute('content');
    store.state.urls.pricelists = document.querySelectorAll('[name="pricelist_url"]')[0].getAttribute('content');;
    store.state.urls.subscriptionBundle = ticketTheatreUrl;
    store.dispatch('getTheatre', {url: ticketTheatreUrl});
  } else{
    let bundleUrl = document.querySelectorAll('[name="bundle_url"]')[0].getAttribute('content');
    let priceListsUrl = document.querySelectorAll('[name="pricelist_url"]')[0].getAttribute('content');
    store.state.urls.pricelists = priceListsUrl;
    store.state.urls.subscriptionBundle = bundleUrl;
    store.dispatch('getTheatre', {url: bundleUrl});
  }
}



let app = new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  created(){
    let page = router.history.current.path.replace('/hnk-4dm1n-t1ck3t/', '');
    if(page !== undefined){
      if(['tlocrt-ulaznice','tlocrt-pretplate','detalji-transakcije', 'uredi'].includes(page)){
        store.dispatch('setActiveTab', 'subscriptions')
      } else{
        let key = null;
        for(key in store.state.receivedData){
          if(store.state.receivedData[key].url == page){
            store.dispatch('setActiveTab', key)
          }
        }
      }
    }
    if(page == ''){
      store.state.pageLoaded = true;
      store.dispatch('getSubscriptions');
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js